import { render, staticRenderFns } from "./ResumenBusqueda.vue?vue&type=template&id=ec796802"
import script from "./ResumenBusqueda.vue?vue&type=script&lang=js"
export * from "./ResumenBusqueda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/74a6e498-56df-5c0c-aa3e-2f5fe39d1378/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec796802')) {
      api.createRecord('ec796802', component.options)
    } else {
      api.reload('ec796802', component.options)
    }
    module.hot.accept("./ResumenBusqueda.vue?vue&type=template&id=ec796802", function () {
      api.rerender('ec796802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ResumenBusqueda.vue"
export default component.exports